import React, { useState } from 'react'
import logo from '../Image/logo.webp'
import login_line from '../Image/Login_line.png'
import { FaGoogle , FaGithub} from "react-icons/fa";
import { signInWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
import { auth, GoogleAuthProvider } from '../firebase';
import { NavLink, useNavigate, Link } from 'react-router-dom'
import { FaFacebook } from 'react-icons/fa6';

function Login({ setUser}) {

  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, seterror] = useState(null)
  
   // Call setShowPro to hide the Pro component
   

  const onLogin = (e) => {
    e.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        setUser(user); // Set user here
        navigate("/home/projects");
        console.log(user);
      })
      .catch((error) => {
        const errorCode = error.code;
        if (errorCode == 'auth/invalid-credential') {
          seterror('this email id is not registred');
        }
        else {
          seterror(error.message);
        }

      });

  }


  const signInWithGoogle = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user;
        setUser(user);
        navigate("/home/projects");
        console.log(user);
      })
      .catch((error) => {
        seterror(error.message);
      });
  }


  return (
    <>
      <div className="flex gap-4 justify-between items-center w-full flex-wrap">
        <div className="flex flex-col py-14 px-10">
          <img src={logo} className='w-52' />
          <p className='text-white text-6xl font-semibold py-5'>Log In</p>
          <div className="bg-secondaryText rounded-md px-3 py-3 mt-5 cursor-pointer  hover:bg-black border border-gray-400">
            <button  onClick={signInWithGoogle}  className='text-white flex flex-row gap-6 w-150 pr-16'>
              <FaGoogle className='text-2xl text-yellow-500' /> Log in with Google
            </button>
          </div>
          <div className="bg-secondaryText rounded-md px-3 py-3 mt-4 cursor-pointer  hover:bg-black border border-gray-400">
            <button type="submit" className='text-white flex flex-row gap-6 w-150 pr-16'>
              <FaGithub className='text-2xl' /> Log in with GitHub
            </button>
          </div>
          

        </div>

        <div className="w-20 flex items-center justify-center mt-48">
          <img src={login_line} />
        </div>

        <div className="mt-56 px-10">
        {error && <p className="text-red-500 mt-2">{error}</p>}
          <form className='flex flex-col gap-1'>
            <p className='text-white cursor-pointer'>Username or Email</p>
            <input type="text" name="email" onChange={(e) => setEmail(e.target.value)} className='bg-gray-300 rounded-md pl-4 pr-32 py-3 border-none outline-none' />
            <p className='text-white mt-6 cursor-pointer'>Password</p>
            <input type="text" name="password" onChange={(e) => setPassword(e.target.value)} className='bg-gray-300 rounded-md pl-4 pr-28 py-3 border-none outline-none' />
            <br />
            <button type="submit" onClick={onLogin} className='bg-emerald-500 text-black rounded-md px-20 py-3 hover:bg-emerald-700'>login</button>
          </form>
        </div>
      </div>

      <p className='text-center py-16 text-white text-sm'>Need an account?<Link className='text-[#76daff] ' to={'/home/signup'}>Sign up now!</Link></p>

    </>
  )
}

export default Login




